import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { normalizeInputNumber } from '../utils';

import { CHECKBOX, STYLED_NUMBER } from '../../Forms/fieldTypes';

const VMSFormComponent = ({
  onSubmit,
  showModal,
  formState = {},
  shouldDisplayCopyToAll,
  ...rest
}) => {
  const { t } = useTransl();
  const formData = [
    {
      keyName: 'residentCanSendKey',
      label: t('visitorSettings.residentCanSendKey'),
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      label: '',
      textBefore: t('visitorSettings.canSendKeys'),
      textAfter: t('visitorSettings.digitalKeys'),
      keyName: 'residentMaxSentKeys',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => normalizeInputNumber(value, 0, 30),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
      disabled: !formState?.residentCanSendKey,
    },
    {
      keyName: 'residentValidUntilLimitEnabled',
      label: t('visitorSettings.residentValidUntilLimitEnabled'),
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      label: '',
      textBefore: t('visitorSettings.validUntilLimit'),
      textAfter: t('visitorSettings.days'),
      keyName: 'residentValidUntilLimitDays',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => normalizeInputNumber(value, 1, 30),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
      disabled: !formState?.residentValidUntilLimitEnabled,
    },
    {
      keyName: 'residentsVisitorsTimeframeLimit',
      label: t('visitorSettings.residentsVisitorsTimeframeLimit'),
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      label: '',
      textBefore: t('visitorSettings.staffMaxSentKeys'),
      textAfter: t('visitorSettings.digitalKeys'),
      keyName: 'staffMaxSentKeys',
      fieldType: STYLED_NUMBER,
      validate: [],
      normalize: (value) => (value < 0 ? 0 : value),
      parse: (value) => Number(value),
      pattern: '[0-9]+',
    },
    {
      keyName: 'pmShouldApproveResidentKey',
      label: t('visitorSettings.pmShouldApproveResidentKey'),
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      keyName: 'visitorPhotoRequired',
      label: t('visitorSettings.visitorPhotoRequired'),
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      keyName: 'createCameraSnapshotOnVisitor',
      label: t('visitorSettings.createCameraSnapshotOnVisitor'),
      fieldType: CHECKBOX,
      validate: [],
    },
    {
      keyName: 'notifyPM',
      label: t('visitorSettings.notifyPM'),
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
  ];
  return (
    <>
      <Box mb={3}>
        <GenericFormContainer
          formData={formData}
          formState={formState}
          onSubmit={onSubmit}
          submitText={t('visitorSettings.updateSettings')}
          backButton={false}
          isFullWidthForm
          {...rest}
        />
      </Box>

      {shouldDisplayCopyToAll && (
        <>
          <Button
            type="button"
            variant="contained"
            disableElevation
            onClick={() => showModal()}
          >
            {t('building.copySettingToAll')}
          </Button>
          <Box py={2}>
            <Typography
              sx={(theme) => ({
                color: theme.palette.custom.settings.warning,
              })}
            >
              {t('building.settingsOverwriteNote')}
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

VMSFormComponent.propTypes = {
  onSubmit: PropTypes.func,
  showModal: PropTypes.func,
  formState: PropTypes.instanceOf(Object),
  shouldDisplayCopyToAll: PropTypes.bool,
};

export default VMSFormComponent;
